/* WellHome home compatibility shim.
 * Interactive modules are loaded once from snippets/wh-quality.liquid.
 */
window.WellHomeHomeAssetLoaded = true;
